import { Grid } from '@mantine/core';
import { useParams } from 'react-router';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';
import classes from './PushNotificationsStats.module.css';

const PushNotificationsStats = ({ pushNotification, stats, period, currency }) => {
  const { accountId, domainId } = useParams();

  const segmentLink = (preset) => {
    return `#/accounts/${accountId}/domains/${domainId}/segments/new?preset=${preset}&id=${pushNotification.id}&startDate=${period.startDate}&endDate=${period.endDate}`;
  };

  if (!stats) {
    return (
      <Grid.Col span={12}>
        <Grid justify="center">
          <LazyLoadSpinner />
        </Grid>
      </Grid.Col>
    );
  } else {
    return (
      <>
        <Grid.Col span={12}>
          <Grid>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Sent"
                stats={stats}
                stat="sent"
                id={pushNotification.id}
                statKey="count"
                link={segmentLink('pushNotificationSend')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Delivered"
                stats={stats}
                stat="deliveries"
                percentageOfStat="sent"
                id={pushNotification.id}
                statKey="count"
                link={segmentLink('pushNotificationDelivery')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Clicks"
                stats={stats}
                stat="clicks"
                percentageOfStat="deliveries"
                id={pushNotification.id}
                statKey="count"
                link={segmentLink('pushNotificationClicks')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Conversions"
                stats={stats}
                stat="conversions"
                percentageOfStat="clicks"
                id={pushNotification.id}
                statKey="count"
                link={segmentLink('pushNotificationConversion')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Purchases"
                stats={stats}
                stat="purchases"
                percentageOfStat="conversions"
                id={pushNotification.id}
                statKey="count"
                link={segmentLink('pushNotificationPurchase')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Revenue"
                stats={stats}
                stat="purchases"
                id={pushNotification.id}
                statKey="value"
                currency={currency}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center" className={classes.separator}>
              <HeaderStatistic
                title="Bounces"
                stats={stats}
                stat="bounces"
                percentageOfStat="sent"
                id={pushNotification.id}
                statKey="count"
                link={segmentLink('pushNotificationBounces')}
              />
            </Grid.Col>
            {pushNotification.inboxMessage && (
              <>
                <Grid.Col span="auto" ta="center" className={classes.separator}>
                  <HeaderStatistic
                    title="Inbox Sent"
                    stats={stats}
                    stat="inboxSent"
                    id={pushNotification.id}
                    statKey="count"
                  />
                </Grid.Col>
                <Grid.Col span="auto" ta="center">
                  <HeaderStatistic
                    title="Inbox Reads"
                    stats={stats}
                    stat="inboxReads"
                    percentageOfStat="inboxSent"
                    id={pushNotification.id}
                    statKey="count"
                  />
                </Grid.Col>
                <Grid.Col span="auto" ta="center">
                  <HeaderStatistic
                    title="Inbox Clicks"
                    stats={stats}
                    stat="inboxClicks"
                    percentageOfStat="inboxReads"
                    id={pushNotification.id}
                    statKey="count"
                  />
                </Grid.Col>
              </>
            )}
          </Grid>
        </Grid.Col>
      </>
    );
  }
};
export default PushNotificationsStats;
